module.exports = __webpack_public_path__ + "img/vue2-toebox_bleu.b5ad0883.png";